import { Injectable } from '@angular/core';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { PutTripQtyI, RiderPayorDetailInterface } from '../interfaces/rider-payor-detail.interface';
import { map } from 'rxjs/operators';
import { constant } from '../../app.constants';
import { IResponseSuccess } from '../interfaces/response.interface';

@Injectable()
export class RiderPayorDetailService extends ParentService{

  constructor(
    private _http: Http
  ) {
    super();
  }

  get (id: number): Observable<RiderPayorDetailInterface[]> {
    return this._http.get(`${constant.RIDER.RIDER_PAYOR_DETAIL.GET_BY_RIDER_PAYOR + id}`, this.getHeader())
      .pipe(
        map((response: any) => response.json() as RiderPayorDetailInterface[])
      ).catch((error: any) => Observable.throw(error.json()));
  }

  post (riderPayorDetail: RiderPayorDetailInterface) {
    const body = JSON.stringify(riderPayorDetail);
    return this._http.post(constant.RIDER.RIDER_PAYOR_DETAIL.BASE, body, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      ).catch((error: any) => Observable.throw(error.json()));
  }

  put (riderPayorDetail: RiderPayorDetailInterface) {
    const body = JSON.stringify(riderPayorDetail);
    return this._http.put(constant.RIDER.RIDER_PAYOR_DETAIL.BASE, body, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      ).catch((error: any) => Observable.throw(error.json()));
  }

  putTripsQty (body: PutTripQtyI) {
    return this._http.put(`${constant.RIDER.RIDER_PAYOR_DETAIL.BASE}UpdateTripsQty`, body, this.headerPost())
      .pipe(
        map((response: any) => response.json())
      ).catch((error: any) => Observable.throw(error.json()));
  }

  getTripsQty (id: number): Observable<RiderPayorDetailInterface[]> {
    return this._http.get(`${constant.RIDER.RIDER_PAYOR_DETAIL.BASE}${id}`, this.getHeader())
      .pipe(
        map((response: any) => response.json() as RiderPayorDetailInterface[])
      ).catch((error: any) => Observable.throw(error.json()));
  }

  delete(ids: number[]): Observable<any>  {
    const url = `${constant.RIDER.RIDER_PAYOR_DETAIL.DELETE_RIDER_PAYOR}`;
    return this._http
      .post(url, ids, this.headerPost())
      .map((resp: Response) => resp.json())
      .catch((error) => Observable.throw(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/rider-payor-detail.service.ts